import type { TFlowKind, TFlowState } from '@besuites/auth/flow';
import flowPurposeOf from '@/function/auth/flow.purpose.of';
import type { TypeFlowAuto, TypeFlowChoice } from '@/types/auth/types.auth.flow';

export default function flowAutoOf(kind: TFlowKind, state: TFlowState, choice: TypeFlowChoice): TypeFlowAuto | null {
    if (state.phase !== 'step' || state.busy !== undefined || state.error !== undefined) return null;
    const by = new Map(state.allowed.map((item) => [item.step, item]));
    const has = (step: string): boolean => by.has(step);

    if (has('totp.enroll.start') && !has('totp.enroll.confirm')) return { step: 'totp.enroll.start', input: {} };
    if (kind === 'recovery' && has('password-recovery.request') && !has('password-recovery.verify-code')) return { step: 'password-recovery.request', input: {} };
    if (choice === 'passkey' && has('passkey.challenge')) return { step: 'passkey.challenge', input: {} };
    if (choice === 'passkey' && has('passkey.register.options')) return { step: 'passkey.register.options', input: {} };
    const send = by.get('email-otp.send');
    if (send === undefined || has('email-otp.verify')) return null;
    if (choice !== 'email-code' && (has('password.verify') || has('totp.verify') || has('password.set') || has('recovery-code.verify') || has('passkey.challenge'))) return null;
    const purpose = flowPurposeOf(kind, send);
    return purpose === null ? null : { step: 'email-otp.send', input: { purpose } };
}
